"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingType = exports.OnboardingStatus = exports.OnboardingReviewItemsEnum = exports.Language = exports.KYCAccessGroupEnum = exports.InvestorTypeEnum = exports.InvestmentTenor = exports.InvestmentObjective = exports.IndexSecurityTypeEnum = exports.HttpExceptionType = exports.FundReturnTenor = exports.EnquiryType = exports.EnfuceTransactionNotificationSubTypeEnum = exports.EnfuceTokenizationNotificationSubTypeEnum = exports.EnfuceTokenizationNotificationStatusEnum = exports.EnfuceTokenizationDeliveryMethodEnum = exports.EnfuceSensitiveInfoEnum = exports.EnfuceSegment = exports.EnfucePaymentReferenceEnum = exports.EnfuceNotificationTypeEnum = exports.EnfuceLocale = exports.EnfuceCardTokenizationVendorEnum = exports.EnfuceCardRole = exports.EnfuceCardPinStatus = exports.EnfuceCardNotificationSubTypeEnum = exports.EnfuceCardNotificationStatusEnum = exports.EnfuceCardNotificationProductionEventEnum = exports.EnfuceAuthenticationTransactionTypeEnum = exports.EnfuceAuthenticationCallbackStatusEnum = exports.EnfuceAurAccountTypeEnum = exports.EnfuceAccountStatusEnum = exports.EnfuceAccountNotificationStatusEnum = exports.EnfuceAccountClosureEnum = exports.DocumentType = exports.DistributionStrategy = exports.DistributionCodeEnum = exports.DisruptionTypeEnum = exports.CustomerType = exports.CurrencyEnum = exports.Complexity = exports.ClaimTypeEnum = exports.CardUsagePeriodLimitCodeEnum = exports.CardUsageLocationCodeEnum = exports.CardStatusEnum = exports.CardSchemeTypeEnum = exports.BillTypeEnum = exports.BillGroupFilterEnum = exports.AurCardTypeEnum = exports.ApplicationScopeEnum = exports.ApplicationEnum = void 0;
exports.VisibilityFilterEnum = exports.UserScopeEnum = exports.UserRole = exports.SurveyType = exports.SubsidiaryEnum = exports.StatusTypeEnum = exports.SignetDocumentStatus = exports.SignatureStatus = exports.Score = exports.RiskScoreEnum = exports.Risk = exports.RealmEnum = exports.QuestionType = exports.QuestionCategory = exports.ProfessionalCategoryEnum = exports.ProductTypeEnum = exports.ProductTermEnum = exports.ProductInterestFrequencyEnum = exports.ProductEntityEnum = exports.ProductClassification = exports.ProductCategoryEnum = exports.PortfolioTransactionTypeEnum = exports.PortfolioTransactionMovementStatusTypeEnum = exports.PaymentTypeEnum = exports.PSD2UnpaidBillClaimTypeEnum = exports.PSD2TransactionStatusEnum = exports.PSD2TransactionBookingStatusEnum = exports.PSD2PeriodicPaymentFrequencyEnum = exports.PSD2PeriodicPaymentExecutionRuleEnum = exports.PSD2AccountStatusEnum = exports.OrderByDirectionEnum = exports.OrderByColumnEnum = exports.OnboardingTypeEnum = void 0;
var ApplicationEnum;
(function (ApplicationEnum) {
    ApplicationEnum["AIIA"] = "AIIA";
    ApplicationEnum["AML_ADMIN"] = "AML_ADMIN";
    ApplicationEnum["AUDUR_API"] = "AUDUR_API";
    ApplicationEnum["AUDUR_CLIENT"] = "AUDUR_CLIENT";
    ApplicationEnum["AUR_API"] = "AUR_API";
    ApplicationEnum["AUR_AWS"] = "AUR_AWS";
    ApplicationEnum["EXMON"] = "EXMON";
    ApplicationEnum["KES_STAFF_MIFID"] = "KES_STAFF_MIFID";
    ApplicationEnum["KES_WEB"] = "KES_WEB";
    ApplicationEnum["KVIKA_CDK"] = "KVIKA_CDK";
    ApplicationEnum["KVIKA_ADMIN_WEB"] = "KVIKA_ADMIN_WEB";
    ApplicationEnum["KVIKA_BACKOFFICE"] = "KVIKA_BACKOFFICE";
    ApplicationEnum["KVIKA_BANKING_AWS"] = "KVIKA_BANKING_AWS";
    ApplicationEnum["KVIKA_FUNDS_WEB"] = "KVIKA_FUNDS_WEB";
    ApplicationEnum["KVIKA_GENERAL_BANKING_WEB"] = "KVIKA_GENERAL_BANKING_WEB";
    ApplicationEnum["KVIKA_ONBOARDING_WEB"] = "KVIKA_ONBOARDING_WEB";
    ApplicationEnum["KVIKA_PORTFOLIO_APP"] = "KVIKA_PORTFOLIO_APP";
    ApplicationEnum["KVIKA_ORION_WEB"] = "KVIKA_ORION_WEB";
    ApplicationEnum["KYC_WEB"] = "KYC_WEB";
    ApplicationEnum["LYKILL_KYC_WEB"] = "LYKILL_KYC_WEB";
    ApplicationEnum["LYKILL_SAP"] = "LYKILL_SAP";
    ApplicationEnum["LYKILL_WEB"] = "LYKILL_WEB";
    ApplicationEnum["NETGIRO_API"] = "NETGIRO_API";
    ApplicationEnum["NETGIRO_WEB"] = "NETGIRO_WEB";
    ApplicationEnum["OUTSYSTEMS_POC"] = "OUTSYSTEMS_POC";
    ApplicationEnum["QA"] = "QA";
    ApplicationEnum["STAFF"] = "STAFF";
    ApplicationEnum["STRAUMUR_API"] = "STRAUMUR_API";
    ApplicationEnum["STRAUMUR_WEB"] = "STRAUMUR_WEB";
    ApplicationEnum["TM_CUSTOMER_PORTAL_WEB"] = "TM_CUSTOMER_PORTAL_WEB";
})(ApplicationEnum = exports.ApplicationEnum || (exports.ApplicationEnum = {}));
var ApplicationScopeEnum;
(function (ApplicationScopeEnum) {
    ApplicationScopeEnum["DEPRECATED_ONE"] = "DEPRECATED_ONE";
    ApplicationScopeEnum["DEPRECATED_TWO"] = "DEPRECATED_TWO";
    ApplicationScopeEnum["DEPRECATED_THREE"] = "DEPRECATED_THREE";
    ApplicationScopeEnum["ASSETS"] = "ASSETS";
    ApplicationScopeEnum["ASSETS__READ"] = "ASSETS__READ";
    ApplicationScopeEnum["ASSETS__READ__ASSETS"] = "ASSETS__READ__ASSETS";
    ApplicationScopeEnum["AUTH"] = "AUTH";
    ApplicationScopeEnum["AUTH__WRITE"] = "AUTH__WRITE";
    ApplicationScopeEnum["AUTH__WRITE__LOGIN"] = "AUTH__WRITE__LOGIN";
    ApplicationScopeEnum["AUTH__WRITE__SESSION_REFRESH"] = "AUTH__WRITE__SESSION_REFRESH";
    ApplicationScopeEnum["AUTH__READ"] = "AUTH__READ";
    ApplicationScopeEnum["AUTH__READ__APPLICATION_SCOPES"] = "AUTH__READ__APPLICATION_SCOPES";
    ApplicationScopeEnum["AUTH__READ__WHITELISTED_IPS"] = "AUTH__READ__WHITELISTED_IPS";
    ApplicationScopeEnum["AUTH__READ__LOGIN"] = "AUTH__READ__LOGIN";
    ApplicationScopeEnum["BANKING"] = "BANKING";
    ApplicationScopeEnum["BANKING__READ"] = "BANKING__READ";
    ApplicationScopeEnum["BANKING__READ__ACCOUNTS"] = "BANKING__READ__ACCOUNTS";
    ApplicationScopeEnum["BANKING__READ__ACCOUNTS_VALIDITY"] = "BANKING__READ__ACCOUNTS_VALIDITY";
    ApplicationScopeEnum["BANKING__READ__FINANCIAL_EVENTS_EVENT_DETAIL"] = "BANKING__READ__FINANCIAL_EVENTS_EVENT_DETAIL";
    ApplicationScopeEnum["BANKING__READ__FINANCIAL_EVENTS_STATEMENT"] = "BANKING__READ__FINANCIAL_EVENTS_STATEMENT";
    ApplicationScopeEnum["BANKING__READ__PAYMENTS"] = "BANKING__READ__PAYMENTS";
    ApplicationScopeEnum["BANKING__READ__PRODUCTS"] = "BANKING__READ__PRODUCTS";
    ApplicationScopeEnum["BANKING__READ__UNPAID_BILLS"] = "BANKING__READ__UNPAID_BILLS";
    ApplicationScopeEnum["BANKING__WRITE"] = "BANKING__WRITE";
    ApplicationScopeEnum["BANKING__WRITE__CLAIM_PAYMENT"] = "BANKING__WRITE__CLAIM_PAYMENT";
    ApplicationScopeEnum["BANKING__WRITE__CREDIT_TRANSFER"] = "BANKING__WRITE__CREDIT_TRANSFER";
    ApplicationScopeEnum["BANKING__WRITE__UNPAID_BILLS"] = "BANKING__WRITE__UNPAID_BILLS";
    ApplicationScopeEnum["BANKING_PRIVATE"] = "BANKING_PRIVATE";
    ApplicationScopeEnum["BANKING_PRIVATE__READ"] = "BANKING_PRIVATE__READ";
    ApplicationScopeEnum["BANKING_PRIVATE__READ__ACCOUNTS_AVAILABILITY"] = "BANKING_PRIVATE__READ__ACCOUNTS_AVAILABILITY";
    ApplicationScopeEnum["BANKING_PRIVATE__WRITE"] = "BANKING_PRIVATE__WRITE";
    ApplicationScopeEnum["BANKING_PRIVATE__WRITE__ACCOUNTS"] = "BANKING_PRIVATE__WRITE__ACCOUNTS";
    ApplicationScopeEnum["BANKING_PRIVATE__WRITE__RESERVATIONS"] = "BANKING_PRIVATE__WRITE__RESERVATIONS";
    ApplicationScopeEnum["COMPANIES"] = "COMPANIES";
    ApplicationScopeEnum["COMPANIES__READ"] = "COMPANIES__READ";
    ApplicationScopeEnum["COMPANIES__READ__COMPANIES"] = "COMPANIES__READ__COMPANIES";
    ApplicationScopeEnum["COMPANIES__READ__COMPANY_USERS"] = "COMPANIES__READ__COMPANY_USERS";
    ApplicationScopeEnum["COMPANIES__WRITE"] = "COMPANIES__WRITE";
    ApplicationScopeEnum["COMPANIES__WRITE__ADDRESSES"] = "COMPANIES__WRITE__ADDRESSES";
    ApplicationScopeEnum["CONTACT"] = "CONTACT";
    ApplicationScopeEnum["CONTACT__WRITE"] = "CONTACT__WRITE";
    ApplicationScopeEnum["CONTACT__WRITE__CONTACT"] = "CONTACT__WRITE__CONTACT";
    ApplicationScopeEnum["DOCUMENTS"] = "DOCUMENTS";
    ApplicationScopeEnum["DOCUMENTS__READ"] = "DOCUMENTS__READ";
    ApplicationScopeEnum["DOCUMENTS__READ__SIGNATURE"] = "DOCUMENTS__READ__SIGNATURE";
    ApplicationScopeEnum["DOCUMENTS__WRITE"] = "DOCUMENTS__WRITE";
    ApplicationScopeEnum["DOCUMENTS__WRITE__SIGNATURE"] = "DOCUMENTS__WRITE__SIGNATURE";
    ApplicationScopeEnum["DOCUMENTS__WRITE__UPLOAD"] = "DOCUMENTS__WRITE__UPLOAD";
    ApplicationScopeEnum["ENFUCE"] = "ENFUCE";
    ApplicationScopeEnum["ENFUCE__READ"] = "ENFUCE__READ";
    ApplicationScopeEnum["ENFUCE__READ__ACCOUNTS"] = "ENFUCE__READ__ACCOUNTS";
    ApplicationScopeEnum["ENFUCE__READ__CARDS"] = "ENFUCE__READ__CARDS";
    ApplicationScopeEnum["ENFUCE__WRITE"] = "ENFUCE__WRITE";
    ApplicationScopeEnum["ENFUCE__WRITE__ACCOUNTS"] = "ENFUCE__WRITE__ACCOUNTS";
    ApplicationScopeEnum["ENFUCE__WRITE__ACCOUNTS_BALANCE"] = "ENFUCE__WRITE__ACCOUNTS_BALANCE";
    ApplicationScopeEnum["ENFUCE__WRITE__ACCOUNTS_SETTLE"] = "ENFUCE__WRITE__ACCOUNTS_SETTLE";
    ApplicationScopeEnum["ENFUCE__WRITE__ACCOUNTS_TRANSACTIONS"] = "ENFUCE__WRITE__ACCOUNTS_TRANSACTIONS";
    ApplicationScopeEnum["ENFUCE__WRITE__CARDS"] = "ENFUCE__WRITE__CARDS";
    ApplicationScopeEnum["ENFUCE__WRITE__CARDS_TOPUP"] = "ENFUCE__WRITE__CARDS_TOPUP";
    ApplicationScopeEnum["ENFUCE__WRITE__FEES"] = "ENFUCE__WRITE__FEES";
    ApplicationScopeEnum["ENFUCE__WRITE__ONBOARD"] = "ENFUCE__WRITE__ONBOARD";
    ApplicationScopeEnum["ENFUCE__WRITE__TRANSACTION_DISCREPANCY"] = "ENFUCE__WRITE__TRANSACTION_DISCREPANCY";
    ApplicationScopeEnum["ENFUCE__WRITE__TRANSACTIONS"] = "ENFUCE__WRITE__TRANSACTIONS";
    ApplicationScopeEnum["INVESTMENTS"] = "INVESTMENTS";
    ApplicationScopeEnum["INVESTMENTS__READ"] = "INVESTMENTS__READ";
    ApplicationScopeEnum["INVESTMENTS__READ__ACCESS"] = "INVESTMENTS__READ__ACCESS";
    ApplicationScopeEnum["INVESTMENTS__READ__FORWARD_CONTRACTS"] = "INVESTMENTS__READ__FORWARD_CONTRACTS";
    ApplicationScopeEnum["INVESTMENTS__READ__FUNDS"] = "INVESTMENTS__READ__FUNDS";
    ApplicationScopeEnum["INVESTMENTS__READ__PORTFOLIOS"] = "INVESTMENTS__READ__PORTFOLIOS";
    ApplicationScopeEnum["INVESTMENTS__READ__SELECTED_USER"] = "INVESTMENTS__READ__SELECTED_USER";
    ApplicationScopeEnum["INVESTMENTS__READ__USERS"] = "INVESTMENTS__READ__USERS";
    ApplicationScopeEnum["INVESTMENTS__WRITE"] = "INVESTMENTS__WRITE";
    ApplicationScopeEnum["INVESTMENTS__WRITE__FUNDS_PURCHASE_REQUEST"] = "INVESTMENTS__WRITE__FUNDS_PURCHASE_REQUEST";
    ApplicationScopeEnum["INVESTMENTS__WRITE__FUNDS_SALE_REQUEST"] = "INVESTMENTS__WRITE__FUNDS_SALE_REQUEST";
    ApplicationScopeEnum["INVESTMENTS__WRITE__RELINQUISH_RIGHTS"] = "INVESTMENTS__WRITE__RELINQUISH_RIGHTS";
    ApplicationScopeEnum["INVESTMENTS__WRITE__SELECTED_USER"] = "INVESTMENTS__WRITE__SELECTED_USER";
    ApplicationScopeEnum["KES"] = "KES";
    ApplicationScopeEnum["KES__READ"] = "KES__READ";
    ApplicationScopeEnum["KES__READ__BANKS"] = "KES__READ__BANKS";
    ApplicationScopeEnum["KES__READ__FUNDS"] = "KES__READ__FUNDS";
    ApplicationScopeEnum["KES__WRITE"] = "KES__WRITE";
    ApplicationScopeEnum["KES__WRITE__FUNDS_PURCHASE_REQUEST"] = "KES__WRITE__FUNDS_PURCHASE_REQUEST";
    ApplicationScopeEnum["KES__WRITE__CONTRACTS"] = "KES__WRITE__CONTRACTS";
    ApplicationScopeEnum["KYC"] = "KYC";
    ApplicationScopeEnum["KYC__READ"] = "KYC__READ";
    ApplicationScopeEnum["KYC__READ__APPROPRIATE_PRODUCTS"] = "KYC__READ__APPROPRIATE_PRODUCTS";
    ApplicationScopeEnum["KYC__READ__CHILDREN"] = "KYC__READ__CHILDREN";
    ApplicationScopeEnum["KYC__READ__COMPANIES"] = "KYC__READ__COMPANIES";
    ApplicationScopeEnum["KYC__READ__SUITABILITY_SUMMARY"] = "KYC__READ__SUITABILITY_SUMMARY";
    ApplicationScopeEnum["KYC__READ__SUITABLE_PRODUCT_CHECK"] = "KYC__READ__SUITABLE_PRODUCT_CHECK";
    ApplicationScopeEnum["KYC__READ__SUITABLE_PRODUCTS"] = "KYC__READ__SUITABLE_PRODUCTS";
    ApplicationScopeEnum["KYC__READ__SURVEY"] = "KYC__READ__SURVEY";
    ApplicationScopeEnum["KYC__READ__SURVEY_ANSWERS"] = "KYC__READ__SURVEY_ANSWERS";
    ApplicationScopeEnum["KYC__WRITE"] = "KYC__WRITE";
    ApplicationScopeEnum["KYC__WRITE__SURVEY_ANSWERS"] = "KYC__WRITE__SURVEY_ANSWERS";
    ApplicationScopeEnum["MARKETDATA"] = "MARKETDATA";
    ApplicationScopeEnum["MARKETDATA__READ"] = "MARKETDATA__READ";
    ApplicationScopeEnum["MARKETDATA__READ__INSTRUMENTS"] = "MARKETDATA__READ__INSTRUMENTS";
    ApplicationScopeEnum["MORTGAGE"] = "MORTGAGE";
    ApplicationScopeEnum["MORTGAGE__READ"] = "MORTGAGE__READ";
    ApplicationScopeEnum["MORTGAGE__READ__MORTGAGE"] = "MORTGAGE__READ__MORTGAGE";
    ApplicationScopeEnum["MORTGAGE__WRITE"] = "MORTGAGE__WRITE";
    ApplicationScopeEnum["MORTGAGE__WRITE__MORTGAGE"] = "MORTGAGE__WRITE__MORTGAGE";
    ApplicationScopeEnum["ONBOARDING"] = "ONBOARDING";
    ApplicationScopeEnum["ONBOARDING__READ"] = "ONBOARDING__READ";
    ApplicationScopeEnum["ONBOARDING__READ__BLOCKERS"] = "ONBOARDING__READ__BLOCKERS";
    ApplicationScopeEnum["ONBOARDING__READ__CAPITAL_MARKETS"] = "ONBOARDING__READ__CAPITAL_MARKETS";
    ApplicationScopeEnum["ONBOARDING__READ__DERIVATIVES"] = "ONBOARDING__READ__DERIVATIVES";
    ApplicationScopeEnum["ONBOARDING__READ__GENERAL_BANKING"] = "ONBOARDING__READ__GENERAL_BANKING";
    ApplicationScopeEnum["ONBOARDING__READ__PRIVATE_BANKING"] = "ONBOARDING__READ__PRIVATE_BANKING";
    ApplicationScopeEnum["ONBOARDING__WRITE"] = "ONBOARDING__WRITE";
    ApplicationScopeEnum["ONBOARDING__WRITE__CAPITAL_MARKETS"] = "ONBOARDING__WRITE__CAPITAL_MARKETS";
    ApplicationScopeEnum["ONBOARDING__WRITE__DERIVATIVES"] = "ONBOARDING__WRITE__DERIVATIVES";
    ApplicationScopeEnum["ONBOARDING__WRITE__GENERAL_BANKING"] = "ONBOARDING__WRITE__GENERAL_BANKING";
    ApplicationScopeEnum["ONBOARDING__WRITE__PIN"] = "ONBOARDING__WRITE__PIN";
    ApplicationScopeEnum["ONBOARDING__WRITE__PRIVATE_BANKING"] = "ONBOARDING__WRITE__PRIVATE_BANKING";
    ApplicationScopeEnum["PSD2"] = "PSD2";
    ApplicationScopeEnum["PSD2READ"] = "PSD2__READ";
    ApplicationScopeEnum["PSD2READACCOUNTS"] = "PSD2__READ__ACCOUNTS";
    ApplicationScopeEnum["PSD2READACCOUNTSVALIDITY"] = "PSD2__READ__ACCOUNTS_VALIDITY";
    ApplicationScopeEnum["PSD2READCOMPANIES"] = "PSD2__READ__COMPANIES";
    ApplicationScopeEnum["PSD2READPAYMENTS"] = "PSD2__READ__PAYMENTS";
    ApplicationScopeEnum["PSD2WRITE"] = "PSD2__WRITE";
    ApplicationScopeEnum["PSD2WRITEPAYMENTS"] = "PSD2__WRITE__PAYMENTS";
    ApplicationScopeEnum["STAFF"] = "STAFF";
    ApplicationScopeEnum["STAFF__READ"] = "STAFF__READ";
    ApplicationScopeEnum["STAFF__READ__AUDUR"] = "STAFF__READ__AUDUR";
    ApplicationScopeEnum["STAFF__READ__COMPANY_USERS"] = "STAFF__READ__COMPANY_USERS";
    ApplicationScopeEnum["STAFF__READ__FLAGS"] = "STAFF__READ__FLAGS";
    ApplicationScopeEnum["STAFF__READ__IDENTITY_CONFIRMATION"] = "STAFF__READ__IDENTITY_CONFIRMATION";
    ApplicationScopeEnum["STAFF__READ__KYC_APPROPRIATE_PRODUCTS"] = "STAFF__READ__KYC_APPROPRIATE_PRODUCTS";
    ApplicationScopeEnum["STAFF__READ__KYC_SUITABILITY_SUMMARY"] = "STAFF__READ__KYC_SUITABILITY_SUMMARY";
    ApplicationScopeEnum["STAFF__READ__KYC_SUITABLE_PRODUCT_CHECK"] = "STAFF__READ__KYC_SUITABLE_PRODUCT_CHECK";
    ApplicationScopeEnum["STAFF__READ__KYC_SUITABLE_PRODUCTS"] = "STAFF__READ__KYC_SUITABLE_PRODUCTS";
    ApplicationScopeEnum["STAFF__READ__KYC_SURVEY_ANSWERS"] = "STAFF__READ__KYC_SURVEY_ANSWERS";
    ApplicationScopeEnum["STAFF__READ__ONBOARDING_CAPITAL_MARKETS"] = "STAFF__READ__ONBOARDING_CAPITAL_MARKETS";
    ApplicationScopeEnum["STAFF__READ__ONBOARDING_PENDING_FORMS"] = "STAFF__READ__ONBOARDING_PENDING_FORMS";
    ApplicationScopeEnum["STAFF__READ__USERS_COMPANIES"] = "STAFF__READ__USERS_COMPANIES";
    ApplicationScopeEnum["STAFF__WRITE"] = "STAFF__WRITE";
    ApplicationScopeEnum["STAFF__WRITE__AUDUR"] = "STAFF__WRITE__AUDUR";
    ApplicationScopeEnum["STAFF__WRITE__COMPANY"] = "STAFF__WRITE__COMPANY";
    ApplicationScopeEnum["STAFF__WRITE__COMPANY_USER"] = "STAFF__WRITE__COMPANY_USER";
    ApplicationScopeEnum["STAFF__WRITE__FLAGS"] = "STAFF__WRITE__FLAGS";
    ApplicationScopeEnum["STAFF__WRITE__INVESTMENTS_FUNDS"] = "STAFF__WRITE__INVESTMENTS_FUNDS";
    ApplicationScopeEnum["STAFF__WRITE__INVESTMENTS_PORTFOLIOS"] = "STAFF__WRITE__INVESTMENTS_PORTFOLIOS";
    ApplicationScopeEnum["STAFF__WRITE__KYC_ACCESS_GROUP"] = "STAFF__WRITE__KYC_ACCESS_GROUP";
    ApplicationScopeEnum["STAFF__WRITE__ONBOARDING_CAPITAL_MARKETS"] = "STAFF__WRITE__ONBOARDING_CAPITAL_MARKETS";
    ApplicationScopeEnum["STAFF__WRITE__ONBOARDING_PENDING_FORMS"] = "STAFF__WRITE__ONBOARDING_PENDING_FORMS";
    ApplicationScopeEnum["STAFF__WRITE__PUSH"] = "STAFF__WRITE__PUSH";
    ApplicationScopeEnum["STAFF__WRITE__USER"] = "STAFF__WRITE__USER";
    ApplicationScopeEnum["STRINGS"] = "STRINGS";
    ApplicationScopeEnum["STRINGS__READ"] = "STRINGS__READ";
    ApplicationScopeEnum["STRINGS__READ__STRINGS"] = "STRINGS__READ__STRINGS";
    ApplicationScopeEnum["USERS"] = "USERS";
    ApplicationScopeEnum["USERS__READ"] = "USERS__READ";
    ApplicationScopeEnum["USERS__READ__DETAILS"] = "USERS__READ__DETAILS";
    ApplicationScopeEnum["USERS__WRITE"] = "USERS__WRITE";
    ApplicationScopeEnum["USERS__WRITE__ADDRESS"] = "USERS__WRITE__ADDRESS";
    ApplicationScopeEnum["USERS__WRITE__EMAIL"] = "USERS__WRITE__EMAIL";
    ApplicationScopeEnum["USERS__WRITE__TERMS"] = "USERS__WRITE__TERMS";
})(ApplicationScopeEnum = exports.ApplicationScopeEnum || (exports.ApplicationScopeEnum = {}));
var AurCardTypeEnum;
(function (AurCardTypeEnum) {
    AurCardTypeEnum["DEBIT"] = "DEBIT";
    AurCardTypeEnum["CREDIT"] = "CREDIT";
    AurCardTypeEnum["HYBRID"] = "HYBRID";
})(AurCardTypeEnum = exports.AurCardTypeEnum || (exports.AurCardTypeEnum = {}));
var BillGroupFilterEnum;
(function (BillGroupFilterEnum) {
    BillGroupFilterEnum["All"] = "All";
    BillGroupFilterEnum["Mandatory"] = "Mandatory";
    BillGroupFilterEnum["Optional"] = "Optional";
})(BillGroupFilterEnum = exports.BillGroupFilterEnum || (exports.BillGroupFilterEnum = {}));
var BillTypeEnum;
(function (BillTypeEnum) {
    BillTypeEnum["Claim"] = "Claim";
    BillTypeEnum["RBLoan"] = "RBLoan";
    BillTypeEnum["Card"] = "Card";
})(BillTypeEnum = exports.BillTypeEnum || (exports.BillTypeEnum = {}));
var CardSchemeTypeEnum;
(function (CardSchemeTypeEnum) {
    CardSchemeTypeEnum["VISA"] = "VISA";
    CardSchemeTypeEnum["MC"] = "MC";
})(CardSchemeTypeEnum = exports.CardSchemeTypeEnum || (exports.CardSchemeTypeEnum = {}));
var CardStatusEnum;
(function (CardStatusEnum) {
    CardStatusEnum["CARD_OK"] = "CARD_OK";
    CardStatusEnum["CARD_BLOCKED"] = "CARD_BLOCKED";
    CardStatusEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    CardStatusEnum["CARD_CLOSED_DUE_TO_FRAUD"] = "CARD_CLOSED_DUE_TO_FRAUD";
    CardStatusEnum["CARD_NO_RENEWAL"] = "CARD_NO_RENEWAL";
    CardStatusEnum["CARD_LOST"] = "CARD_LOST";
    CardStatusEnum["CARD_STOLEN"] = "CARD_STOLEN";
    CardStatusEnum["CARD_CLOSED"] = "CARD_CLOSED";
    CardStatusEnum["CARD_EXPIRED"] = "CARD_EXPIRED";
})(CardStatusEnum = exports.CardStatusEnum || (exports.CardStatusEnum = {}));
var CardUsageLocationCodeEnum;
(function (CardUsageLocationCodeEnum) {
    CardUsageLocationCodeEnum["ATM"] = "ATM";
    CardUsageLocationCodeEnum["RETAIL"] = "RETAIL";
    CardUsageLocationCodeEnum["ALL"] = "ALL";
})(CardUsageLocationCodeEnum = exports.CardUsageLocationCodeEnum || (exports.CardUsageLocationCodeEnum = {}));
var CardUsagePeriodLimitCodeEnum;
(function (CardUsagePeriodLimitCodeEnum) {
    CardUsagePeriodLimitCodeEnum["Value24H"] = "24H";
    CardUsagePeriodLimitCodeEnum["DAILY"] = "DAILY";
    CardUsagePeriodLimitCodeEnum["MONTHLY"] = "MONTHLY";
    CardUsagePeriodLimitCodeEnum["WEEKLY"] = "WEEKLY";
})(CardUsagePeriodLimitCodeEnum = exports.CardUsagePeriodLimitCodeEnum || (exports.CardUsagePeriodLimitCodeEnum = {}));
var ClaimTypeEnum;
(function (ClaimTypeEnum) {
    ClaimTypeEnum["NormalClaim"] = "NormalClaim";
    ClaimTypeEnum["LightClaim"] = "LightClaim";
    ClaimTypeEnum["OptionalPaymentClaim"] = "OptionalPaymentClaim";
    ClaimTypeEnum["LightOptionalPaymentClaim"] = "LightOptionalPaymentClaim";
    ClaimTypeEnum["GovernmentalClaim"] = "GovernmentalClaim";
    ClaimTypeEnum["BalanceClaim"] = "BalanceClaim";
})(ClaimTypeEnum = exports.ClaimTypeEnum || (exports.ClaimTypeEnum = {}));
var Complexity;
(function (Complexity) {
    Complexity["None"] = "None";
    Complexity["NonComplex"] = "NonComplex";
    Complexity["Complex"] = "Complex";
})(Complexity = exports.Complexity || (exports.Complexity = {}));
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["AED"] = "AED";
    CurrencyEnum["AFN"] = "AFN";
    CurrencyEnum["ALL"] = "ALL";
    CurrencyEnum["AMD"] = "AMD";
    CurrencyEnum["ANG"] = "ANG";
    CurrencyEnum["AOA"] = "AOA";
    CurrencyEnum["ARS"] = "ARS";
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["AWG"] = "AWG";
    CurrencyEnum["AZN"] = "AZN";
    CurrencyEnum["BAM"] = "BAM";
    CurrencyEnum["BBD"] = "BBD";
    CurrencyEnum["BDT"] = "BDT";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["BHD"] = "BHD";
    CurrencyEnum["BIF"] = "BIF";
    CurrencyEnum["BMD"] = "BMD";
    CurrencyEnum["BND"] = "BND";
    CurrencyEnum["BOB"] = "BOB";
    CurrencyEnum["BOV"] = "BOV";
    CurrencyEnum["BRL"] = "BRL";
    CurrencyEnum["BSD"] = "BSD";
    CurrencyEnum["BTN"] = "BTN";
    CurrencyEnum["BWP"] = "BWP";
    CurrencyEnum["BYN"] = "BYN";
    CurrencyEnum["BZD"] = "BZD";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["CDF"] = "CDF";
    CurrencyEnum["CHE"] = "CHE";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CHW"] = "CHW";
    CurrencyEnum["CLF"] = "CLF";
    CurrencyEnum["CLP"] = "CLP";
    CurrencyEnum["CNY"] = "CNY";
    CurrencyEnum["COP"] = "COP";
    CurrencyEnum["COU"] = "COU";
    CurrencyEnum["CRC"] = "CRC";
    CurrencyEnum["CUC"] = "CUC";
    CurrencyEnum["CUP"] = "CUP";
    CurrencyEnum["CVE"] = "CVE";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["DJF"] = "DJF";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["DOP"] = "DOP";
    CurrencyEnum["DZD"] = "DZD";
    CurrencyEnum["EEK"] = "EEK";
    CurrencyEnum["EGP"] = "EGP";
    CurrencyEnum["ERN"] = "ERN";
    CurrencyEnum["ETB"] = "ETB";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["FJD"] = "FJD";
    CurrencyEnum["FKP"] = "FKP";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["GEL"] = "GEL";
    CurrencyEnum["GHS"] = "GHS";
    CurrencyEnum["GIP"] = "GIP";
    CurrencyEnum["GMD"] = "GMD";
    CurrencyEnum["GNF"] = "GNF";
    CurrencyEnum["GTQ"] = "GTQ";
    CurrencyEnum["GYD"] = "GYD";
    CurrencyEnum["HKD"] = "HKD";
    CurrencyEnum["HNL"] = "HNL";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["HTG"] = "HTG";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["IDR"] = "IDR";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["INR"] = "INR";
    CurrencyEnum["IQD"] = "IQD";
    CurrencyEnum["IRR"] = "IRR";
    CurrencyEnum["ISK"] = "ISK";
    CurrencyEnum["JMD"] = "JMD";
    CurrencyEnum["JOD"] = "JOD";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["KES"] = "KES";
    CurrencyEnum["KGS"] = "KGS";
    CurrencyEnum["KHR"] = "KHR";
    CurrencyEnum["KMF"] = "KMF";
    CurrencyEnum["KPW"] = "KPW";
    CurrencyEnum["KRW"] = "KRW";
    CurrencyEnum["KWD"] = "KWD";
    CurrencyEnum["KYD"] = "KYD";
    CurrencyEnum["KZT"] = "KZT";
    CurrencyEnum["LAK"] = "LAK";
    CurrencyEnum["LBP"] = "LBP";
    CurrencyEnum["LKR"] = "LKR";
    CurrencyEnum["LRD"] = "LRD";
    CurrencyEnum["LSL"] = "LSL";
    CurrencyEnum["LTL"] = "LTL";
    CurrencyEnum["LVL"] = "LVL";
    CurrencyEnum["LYD"] = "LYD";
    CurrencyEnum["MAD"] = "MAD";
    CurrencyEnum["MDL"] = "MDL";
    CurrencyEnum["MGA"] = "MGA";
    CurrencyEnum["MKD"] = "MKD";
    CurrencyEnum["MMK"] = "MMK";
    CurrencyEnum["MNT"] = "MNT";
    CurrencyEnum["MOP"] = "MOP";
    CurrencyEnum["MRU"] = "MRU";
    CurrencyEnum["MTL"] = "MTL";
    CurrencyEnum["MUR"] = "MUR";
    CurrencyEnum["MVR"] = "MVR";
    CurrencyEnum["MWK"] = "MWK";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["MXV"] = "MXV";
    CurrencyEnum["MYR"] = "MYR";
    CurrencyEnum["MZN"] = "MZN";
    CurrencyEnum["NAD"] = "NAD";
    CurrencyEnum["NGN"] = "NGN";
    CurrencyEnum["NIO"] = "NIO";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["NPR"] = "NPR";
    CurrencyEnum["NZD"] = "NZD";
    CurrencyEnum["OMR"] = "OMR";
    CurrencyEnum["PAB"] = "PAB";
    CurrencyEnum["PEN"] = "PEN";
    CurrencyEnum["PGK"] = "PGK";
    CurrencyEnum["PHP"] = "PHP";
    CurrencyEnum["PKR"] = "PKR";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["PYG"] = "PYG";
    CurrencyEnum["QAR"] = "QAR";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["RSD"] = "RSD";
    CurrencyEnum["RUB"] = "RUB";
    CurrencyEnum["RWF"] = "RWF";
    CurrencyEnum["SAR"] = "SAR";
    CurrencyEnum["SBD"] = "SBD";
    CurrencyEnum["SCR"] = "SCR";
    CurrencyEnum["SDG"] = "SDG";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["SKK"] = "SKK";
    CurrencyEnum["SHP"] = "SHP";
    CurrencyEnum["SLL"] = "SLL";
    CurrencyEnum["SOS"] = "SOS";
    CurrencyEnum["SRD"] = "SRD";
    CurrencyEnum["SSP"] = "SSP";
    CurrencyEnum["STN"] = "STN";
    CurrencyEnum["SVC"] = "SVC";
    CurrencyEnum["SYP"] = "SYP";
    CurrencyEnum["SZL"] = "SZL";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["TJS"] = "TJS";
    CurrencyEnum["TMT"] = "TMT";
    CurrencyEnum["TND"] = "TND";
    CurrencyEnum["TOP"] = "TOP";
    CurrencyEnum["TRY"] = "TRY";
    CurrencyEnum["TTD"] = "TTD";
    CurrencyEnum["TWD"] = "TWD";
    CurrencyEnum["TZS"] = "TZS";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["UGX"] = "UGX";
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["USN"] = "USN";
    CurrencyEnum["UYI"] = "UYI";
    CurrencyEnum["UYU"] = "UYU";
    CurrencyEnum["UYW"] = "UYW";
    CurrencyEnum["UZS"] = "UZS";
    CurrencyEnum["VES"] = "VES";
    CurrencyEnum["VND"] = "VND";
    CurrencyEnum["VUV"] = "VUV";
    CurrencyEnum["WST"] = "WST";
    CurrencyEnum["XAF"] = "XAF";
    CurrencyEnum["XAG"] = "XAG";
    CurrencyEnum["XAU"] = "XAU";
    CurrencyEnum["XBA"] = "XBA";
    CurrencyEnum["XBB"] = "XBB";
    CurrencyEnum["XBC"] = "XBC";
    CurrencyEnum["XBD"] = "XBD";
    CurrencyEnum["XCD"] = "XCD";
    CurrencyEnum["XDR"] = "XDR";
    CurrencyEnum["XOF"] = "XOF";
    CurrencyEnum["XPD"] = "XPD";
    CurrencyEnum["XPF"] = "XPF";
    CurrencyEnum["XPT"] = "XPT";
    CurrencyEnum["XSU"] = "XSU";
    CurrencyEnum["XTS"] = "XTS";
    CurrencyEnum["XUA"] = "XUA";
    CurrencyEnum["YER"] = "YER";
    CurrencyEnum["ZAR"] = "ZAR";
    CurrencyEnum["ZMW"] = "ZMW";
    CurrencyEnum["ZWL"] = "ZWL";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
var CustomerType;
(function (CustomerType) {
    CustomerType["Individual"] = "Individual";
    CustomerType["Company"] = "Company";
    CustomerType["IndividualOrCompany"] = "IndividualOrCompany";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
var DisruptionTypeEnum;
(function (DisruptionTypeEnum) {
    DisruptionTypeEnum["MAINTENANCE"] = "MAINTENANCE";
    DisruptionTypeEnum["EXTERNAL"] = "EXTERNAL";
})(DisruptionTypeEnum = exports.DisruptionTypeEnum || (exports.DisruptionTypeEnum = {}));
var DistributionCodeEnum;
(function (DistributionCodeEnum) {
    DistributionCodeEnum["AUDUR"] = "AUDUR";
    DistributionCodeEnum["KES"] = "KES";
    DistributionCodeEnum["AKTA"] = "AKTA";
})(DistributionCodeEnum = exports.DistributionCodeEnum || (exports.DistributionCodeEnum = {}));
var DistributionStrategy;
(function (DistributionStrategy) {
    DistributionStrategy["All"] = "All";
    DistributionStrategy["Execution"] = "Execution";
    DistributionStrategy["PrivateBanking"] = "PrivateBanking";
})(DistributionStrategy = exports.DistributionStrategy || (exports.DistributionStrategy = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["AUDUR__PEP"] = "AUDUR__PEP";
    DocumentType["AUDUR__REGISTRATION"] = "AUDUR__REGISTRATION";
    DocumentType["AUDUR__TERM_DEPOSIT_CONDITIONS"] = "AUDUR__TERM_DEPOSIT_CONDITIONS";
    DocumentType["AUDUR__TERM_DEPOSIT_CONFIRMATION"] = "AUDUR__TERM_DEPOSIT_CONFIRMATION";
    DocumentType["INVESTMENTS__RELINQUISH_PROTECTION_RIGHTS"] = "INVESTMENTS__RELINQUISH_PROTECTION_RIGHTS";
    DocumentType["KES__FUND_PURCHASE_REQUEST"] = "KES__FUND_PURCHASE_REQUEST";
    DocumentType["KVIKA__PEP"] = "KVIKA__PEP";
    DocumentType["ONBOARDING_CAPITAL_MARKETS__AGREEMENT_INDIVIDUAL"] = "ONBOARDING_CAPITAL_MARKETS__AGREEMENT_INDIVIDUAL";
    DocumentType["ONBOARDING_CAPITAL_MARKETS__AGREEMENT_COMPANY"] = "ONBOARDING_CAPITAL_MARKETS__AGREEMENT_COMPANY";
    DocumentType["ONBOARDING_CAPITAL_MARKETS__PROFESSIONAL_GENERAL"] = "ONBOARDING_CAPITAL_MARKETS__PROFESSIONAL_GENERAL";
    DocumentType["ONBOARDING_CAPITAL_MARKETS__PROFESSIONAL_CORPORATION"] = "ONBOARDING_CAPITAL_MARKETS__PROFESSIONAL_CORPORATION";
    DocumentType["ONBOARDING_DERIVATIVES__AGREEMENT_INDIVIDUAL"] = "ONBOARDING_DERIVATIVES__AGREEMENT_INDIVIDUAL";
    DocumentType["ONBOARDING_DERIVATIVES__AGREEMENT_COMPANY"] = "ONBOARDING_DERIVATIVES__AGREEMENT_COMPANY";
    DocumentType["ONBOARDING_GENERAL_BANKING__AGREEMENT_INDIVIDUAL"] = "ONBOARDING_GENERAL_BANKING__AGREEMENT_INDIVIDUAL";
    DocumentType["ONBOARDING_GENERAL_BANKING__AGREEMENT_COMPANY"] = "ONBOARDING_GENERAL_BANKING__AGREEMENT_COMPANY";
    DocumentType["KES__INVESTMENT_ADVICE_WITH_CUSTODY_ACCOUNT_CONTRACT"] = "KES__INVESTMENT_ADVICE_WITH_CUSTODY_ACCOUNT_CONTRACT";
    DocumentType["KES__ASSET_MANAGEMENT_WITH_PERFORMANCE_FEE_CONTRACT"] = "KES__ASSET_MANAGEMENT_WITH_PERFORMANCE_FEE_CONTRACT";
    DocumentType["KES__ASSET_MANAGEMENT_WITHOUT_PERFORMANCE_FEE_CONTRACT"] = "KES__ASSET_MANAGEMENT_WITHOUT_PERFORMANCE_FEE_CONTRACT";
    DocumentType["KES__CUSTOM_PORTFOLIO_WITH_PERFORMANCE_FEE_CONTRACT"] = "KES__CUSTOM_PORTFOLIO_WITH_PERFORMANCE_FEE_CONTRACT";
    DocumentType["KES__CUSTOM_PORTFOLIO_WITHOUT_PERFORMANCE_FEE_CONTRACT"] = "KES__CUSTOM_PORTFOLIO_WITHOUT_PERFORMANCE_FEE_CONTRACT";
    DocumentType["KES__INVESTMENTS_STRATEGY_WITHOUT_PERFORMANCE_FEE_CONTRACT"] = "KES__INVESTMENTS_STRATEGY_WITHOUT_PERFORMANCE_FEE_CONTRACT";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var EnfuceAccountClosureEnum;
(function (EnfuceAccountClosureEnum) {
    EnfuceAccountClosureEnum["CLOSED1"] = "CLOSED1";
    EnfuceAccountClosureEnum["CLOSED2"] = "CLOSED2";
    EnfuceAccountClosureEnum["CLOSED3"] = "CLOSED3";
    EnfuceAccountClosureEnum["CLOSED4"] = "CLOSED4";
    EnfuceAccountClosureEnum["CLOSED5"] = "CLOSED5";
})(EnfuceAccountClosureEnum = exports.EnfuceAccountClosureEnum || (exports.EnfuceAccountClosureEnum = {}));
var EnfuceAccountNotificationStatusEnum;
(function (EnfuceAccountNotificationStatusEnum) {
    EnfuceAccountNotificationStatusEnum["ACCOUNT_BLOCKED"] = "ACCOUNT_BLOCKED";
    EnfuceAccountNotificationStatusEnum["ACCOUNT_COLLECTION"] = "ACCOUNT_COLLECTION";
    EnfuceAccountNotificationStatusEnum["ACCOUNT_OK"] = "ACCOUNT_OK";
    EnfuceAccountNotificationStatusEnum["ACCOUNT_TO_CLOSE"] = "ACCOUNT_TO_CLOSE";
    EnfuceAccountNotificationStatusEnum["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    EnfuceAccountNotificationStatusEnum["ACCOUNT_AUTO_CLOSED"] = "ACCOUNT_AUTO_CLOSED";
})(EnfuceAccountNotificationStatusEnum = exports.EnfuceAccountNotificationStatusEnum || (exports.EnfuceAccountNotificationStatusEnum = {}));
var EnfuceAccountStatusEnum;
(function (EnfuceAccountStatusEnum) {
    EnfuceAccountStatusEnum["ACCOUNT_BLOCKED"] = "ACCOUNT_BLOCKED";
    EnfuceAccountStatusEnum["ACCOUNT_OK"] = "ACCOUNT_OK";
    EnfuceAccountStatusEnum["ACCOUNT_TO_CLOSE"] = "ACCOUNT_TO_CLOSE";
    EnfuceAccountStatusEnum["ACCOUNT_COLLECTION"] = "ACCOUNT_COLLECTION";
    EnfuceAccountStatusEnum["ACCOUNT_AUTO_CLOSED"] = "ACCOUNT_AUTO_CLOSED";
    EnfuceAccountStatusEnum["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
})(EnfuceAccountStatusEnum = exports.EnfuceAccountStatusEnum || (exports.EnfuceAccountStatusEnum = {}));
var EnfuceAurAccountTypeEnum;
(function (EnfuceAurAccountTypeEnum) {
    EnfuceAurAccountTypeEnum["FREE"] = "FREE";
    EnfuceAurAccountTypeEnum["PAID"] = "PAID";
})(EnfuceAurAccountTypeEnum = exports.EnfuceAurAccountTypeEnum || (exports.EnfuceAurAccountTypeEnum = {}));
var EnfuceAuthenticationCallbackStatusEnum;
(function (EnfuceAuthenticationCallbackStatusEnum) {
    EnfuceAuthenticationCallbackStatusEnum["SUCCESS"] = "SUCCESS";
    EnfuceAuthenticationCallbackStatusEnum["FAIL"] = "FAIL";
    EnfuceAuthenticationCallbackStatusEnum["ERROR"] = "ERROR";
    EnfuceAuthenticationCallbackStatusEnum["TIMEOUT"] = "TIMEOUT";
})(EnfuceAuthenticationCallbackStatusEnum = exports.EnfuceAuthenticationCallbackStatusEnum || (exports.EnfuceAuthenticationCallbackStatusEnum = {}));
var EnfuceAuthenticationTransactionTypeEnum;
(function (EnfuceAuthenticationTransactionTypeEnum) {
    EnfuceAuthenticationTransactionTypeEnum["PAYMENT"] = "PAYMENT";
    EnfuceAuthenticationTransactionTypeEnum["RECURRING"] = "RECURRING";
})(EnfuceAuthenticationTransactionTypeEnum = exports.EnfuceAuthenticationTransactionTypeEnum || (exports.EnfuceAuthenticationTransactionTypeEnum = {}));
var EnfuceCardNotificationProductionEventEnum;
(function (EnfuceCardNotificationProductionEventEnum) {
    EnfuceCardNotificationProductionEventEnum["NCRD"] = "NCRD";
    EnfuceCardNotificationProductionEventEnum["NLOST"] = "NLOST";
    EnfuceCardNotificationProductionEventEnum["NVRT"] = "NVRT";
    EnfuceCardNotificationProductionEventEnum["RALLRE"] = "RALLRE";
    EnfuceCardNotificationProductionEventEnum["ROPIN"] = "ROPIN";
    EnfuceCardNotificationProductionEventEnum["RPL"] = "RPL";
    EnfuceCardNotificationProductionEventEnum["RPLRE"] = "RPLRE";
    EnfuceCardNotificationProductionEventEnum["RVRT"] = "RVRT";
    EnfuceCardNotificationProductionEventEnum["RALLMIG"] = "RALLMIG";
    EnfuceCardNotificationProductionEventEnum["RALLMIG_EXPIRED"] = "RALLMIG_EXPIRED";
})(EnfuceCardNotificationProductionEventEnum = exports.EnfuceCardNotificationProductionEventEnum || (exports.EnfuceCardNotificationProductionEventEnum = {}));
var EnfuceCardNotificationStatusEnum;
(function (EnfuceCardNotificationStatusEnum) {
    EnfuceCardNotificationStatusEnum["CARD_OK"] = "CARD_OK";
    EnfuceCardNotificationStatusEnum["CARD_BLOCKED"] = "CARD_BLOCKED";
    EnfuceCardNotificationStatusEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    EnfuceCardNotificationStatusEnum["CARD_CLOSED_DUE_TO_FRAUD"] = "CARD_CLOSED_DUE_TO_FRAUD";
    EnfuceCardNotificationStatusEnum["CARD_NO_RENEWAL"] = "CARD_NO_RENEWAL";
    EnfuceCardNotificationStatusEnum["CARD_LOST"] = "CARD_LOST";
    EnfuceCardNotificationStatusEnum["CARD_STOLEN"] = "CARD_STOLEN";
    EnfuceCardNotificationStatusEnum["CARD_CLOSED"] = "CARD_CLOSED";
    EnfuceCardNotificationStatusEnum["CARD_EXPIRED"] = "CARD_EXPIRED";
})(EnfuceCardNotificationStatusEnum = exports.EnfuceCardNotificationStatusEnum || (exports.EnfuceCardNotificationStatusEnum = {}));
var EnfuceCardNotificationSubTypeEnum;
(function (EnfuceCardNotificationSubTypeEnum) {
    EnfuceCardNotificationSubTypeEnum["PRODUCTION_EVENT"] = "PRODUCTION_EVENT";
    EnfuceCardNotificationSubTypeEnum["STATUS_CHANGE"] = "STATUS_CHANGE";
})(EnfuceCardNotificationSubTypeEnum = exports.EnfuceCardNotificationSubTypeEnum || (exports.EnfuceCardNotificationSubTypeEnum = {}));
var EnfuceCardPinStatus;
(function (EnfuceCardPinStatus) {
    EnfuceCardPinStatus["D"] = "D";
    EnfuceCardPinStatus["W"] = "W";
    EnfuceCardPinStatus["S"] = "S";
})(EnfuceCardPinStatus = exports.EnfuceCardPinStatus || (exports.EnfuceCardPinStatus = {}));
var EnfuceCardRole;
(function (EnfuceCardRole) {
    EnfuceCardRole["MAIN"] = "MAIN";
    EnfuceCardRole["SUPPLEMENTARY"] = "SUPPLEMENTARY";
})(EnfuceCardRole = exports.EnfuceCardRole || (exports.EnfuceCardRole = {}));
var EnfuceCardTokenizationVendorEnum;
(function (EnfuceCardTokenizationVendorEnum) {
    EnfuceCardTokenizationVendorEnum["APPLE"] = "APPLE";
    EnfuceCardTokenizationVendorEnum["GOOGLE"] = "GOOGLE";
    EnfuceCardTokenizationVendorEnum["SAMSUNG"] = "SAMSUNG";
    EnfuceCardTokenizationVendorEnum["MDES"] = "MDES";
    EnfuceCardTokenizationVendorEnum["IN_APP"] = "IN_APP";
})(EnfuceCardTokenizationVendorEnum = exports.EnfuceCardTokenizationVendorEnum || (exports.EnfuceCardTokenizationVendorEnum = {}));
var EnfuceLocale;
(function (EnfuceLocale) {
    EnfuceLocale["DeAT"] = "de_AT";
    EnfuceLocale["CaES"] = "ca_ES";
    EnfuceLocale["DeDE"] = "de_DE";
    EnfuceLocale["EnGB"] = "en_GB";
    EnfuceLocale["EsES"] = "es_ES";
    EnfuceLocale["FiFI"] = "fi_FI";
    EnfuceLocale["FoFO"] = "fo_FO";
    EnfuceLocale["FrFR"] = "fr_FR";
    EnfuceLocale["GaIE"] = "ga_IE";
    EnfuceLocale["IsIS"] = "is_IS";
    EnfuceLocale["ItIT"] = "it_IT";
    EnfuceLocale["KlGL"] = "kl_GL";
    EnfuceLocale["NoNO"] = "no_NO";
    EnfuceLocale["SvFI"] = "sv_FI";
    EnfuceLocale["SvSE"] = "sv_SE";
    EnfuceLocale["NlNL"] = "nl_NL";
    EnfuceLocale["DeNL"] = "de_NL";
    EnfuceLocale["FrNL"] = "fr_NL";
    EnfuceLocale["FrBE"] = "fr_BE";
    EnfuceLocale["NlBE"] = "nl_BE";
    EnfuceLocale["EtEE"] = "et_EE";
    EnfuceLocale["LvLV"] = "lv_LV";
    EnfuceLocale["PtPT"] = "pt_PT";
    EnfuceLocale["LtLT"] = "lt_LT";
    EnfuceLocale["DaDK"] = "da_DK";
    EnfuceLocale["MtMT"] = "mt_MT";
})(EnfuceLocale = exports.EnfuceLocale || (exports.EnfuceLocale = {}));
var EnfuceNotificationTypeEnum;
(function (EnfuceNotificationTypeEnum) {
    EnfuceNotificationTypeEnum["ACCOUNT"] = "ACCOUNT";
    EnfuceNotificationTypeEnum["CARD"] = "CARD";
    EnfuceNotificationTypeEnum["TRANSACTION"] = "TRANSACTION";
    EnfuceNotificationTypeEnum["TOKENIZATION"] = "TOKENIZATION";
})(EnfuceNotificationTypeEnum = exports.EnfuceNotificationTypeEnum || (exports.EnfuceNotificationTypeEnum = {}));
var EnfucePaymentReferenceEnum;
(function (EnfucePaymentReferenceEnum) {
    EnfucePaymentReferenceEnum["MOD10"] = "MOD10";
    EnfucePaymentReferenceEnum["FINNISH731"] = "FINNISH_7_3_1";
    EnfucePaymentReferenceEnum["CUSTOMER_SPECIFIC"] = "CUSTOMER_SPECIFIC";
})(EnfucePaymentReferenceEnum = exports.EnfucePaymentReferenceEnum || (exports.EnfucePaymentReferenceEnum = {}));
var EnfuceSegment;
(function (EnfuceSegment) {
    EnfuceSegment["SEGMENT_A"] = "SEGMENT_A";
    EnfuceSegment["SEGMENT_B"] = "SEGMENT_B";
    EnfuceSegment["SEGMENT_C"] = "SEGMENT_C";
    EnfuceSegment["SEGMENT_D"] = "SEGMENT_D";
    EnfuceSegment["SEGMENT_E"] = "SEGMENT_E";
    EnfuceSegment["SEGMENT_F"] = "SEGMENT_F";
})(EnfuceSegment = exports.EnfuceSegment || (exports.EnfuceSegment = {}));
var EnfuceSensitiveInfoEnum;
(function (EnfuceSensitiveInfoEnum) {
    EnfuceSensitiveInfoEnum["PAN"] = "PAN";
    EnfuceSensitiveInfoEnum["VIEW_PIN"] = "VIEW_PIN";
    EnfuceSensitiveInfoEnum["SET_PIN"] = "SET_PIN";
})(EnfuceSensitiveInfoEnum = exports.EnfuceSensitiveInfoEnum || (exports.EnfuceSensitiveInfoEnum = {}));
var EnfuceTokenizationDeliveryMethodEnum;
(function (EnfuceTokenizationDeliveryMethodEnum) {
    EnfuceTokenizationDeliveryMethodEnum["EMAIL"] = "EMAIL";
    EnfuceTokenizationDeliveryMethodEnum["SMS"] = "SMS";
})(EnfuceTokenizationDeliveryMethodEnum = exports.EnfuceTokenizationDeliveryMethodEnum || (exports.EnfuceTokenizationDeliveryMethodEnum = {}));
var EnfuceTokenizationNotificationStatusEnum;
(function (EnfuceTokenizationNotificationStatusEnum) {
    EnfuceTokenizationNotificationStatusEnum["ACTIVE"] = "ACTIVE";
    EnfuceTokenizationNotificationStatusEnum["DEACTIVATED"] = "DEACTIVATED";
    EnfuceTokenizationNotificationStatusEnum["INACTIVE"] = "INACTIVE";
    EnfuceTokenizationNotificationStatusEnum["SUSPENDED"] = "SUSPENDED";
})(EnfuceTokenizationNotificationStatusEnum = exports.EnfuceTokenizationNotificationStatusEnum || (exports.EnfuceTokenizationNotificationStatusEnum = {}));
var EnfuceTokenizationNotificationSubTypeEnum;
(function (EnfuceTokenizationNotificationSubTypeEnum) {
    EnfuceTokenizationNotificationSubTypeEnum["ACTIVE"] = "ACTIVE";
    EnfuceTokenizationNotificationSubTypeEnum["STATUS_CHANGE"] = "STATUS_CHANGE";
    EnfuceTokenizationNotificationSubTypeEnum["TOKENIZATION_REQUEST"] = "TOKENIZATION_REQUEST";
})(EnfuceTokenizationNotificationSubTypeEnum = exports.EnfuceTokenizationNotificationSubTypeEnum || (exports.EnfuceTokenizationNotificationSubTypeEnum = {}));
var EnfuceTransactionNotificationSubTypeEnum;
(function (EnfuceTransactionNotificationSubTypeEnum) {
    EnfuceTransactionNotificationSubTypeEnum["AUTH"] = "AUTH";
    EnfuceTransactionNotificationSubTypeEnum["AUTH_REV"] = "AUTH_REV";
    EnfuceTransactionNotificationSubTypeEnum["AUTH_ADJ"] = "AUTH_ADJ";
    EnfuceTransactionNotificationSubTypeEnum["AUTH_ADV"] = "AUTH_ADV";
    EnfuceTransactionNotificationSubTypeEnum["FINANCIAL"] = "FINANCIAL";
})(EnfuceTransactionNotificationSubTypeEnum = exports.EnfuceTransactionNotificationSubTypeEnum || (exports.EnfuceTransactionNotificationSubTypeEnum = {}));
var EnquiryType;
(function (EnquiryType) {
    EnquiryType["AudurGeneral"] = "audur_general";
    EnquiryType["Compliance"] = "compliance";
    EnquiryType["General"] = "general";
})(EnquiryType = exports.EnquiryType || (exports.EnquiryType = {}));
var FundReturnTenor;
(function (FundReturnTenor) {
    FundReturnTenor["TD"] = "TD";
    FundReturnTenor["Value1W"] = "1W";
    FundReturnTenor["MTD"] = "MTD";
    FundReturnTenor["YTD"] = "YTD";
    FundReturnTenor["Value1M"] = "1M";
    FundReturnTenor["Value3M"] = "3M";
    FundReturnTenor["Value6M"] = "6M";
    FundReturnTenor["START"] = "START";
})(FundReturnTenor = exports.FundReturnTenor || (exports.FundReturnTenor = {}));
var HttpExceptionType;
(function (HttpExceptionType) {
    HttpExceptionType["AUDUR_ERROR"] = "AUDUR_ERROR";
    HttpExceptionType["AUTH_ERROR"] = "AUTH_ERROR";
    HttpExceptionType["MAINTENANCE_MODE"] = "MAINTENANCE_MODE";
    HttpExceptionType["SOPRA_MIGRATION"] = "SOPRA_MIGRATION";
})(HttpExceptionType = exports.HttpExceptionType || (exports.HttpExceptionType = {}));
var IndexSecurityTypeEnum;
(function (IndexSecurityTypeEnum) {
    IndexSecurityTypeEnum["BOND"] = "BOND";
    IndexSecurityTypeEnum["EQUITY"] = "EQUITY";
    IndexSecurityTypeEnum["INDEX"] = "INDEX";
    IndexSecurityTypeEnum["OTHER"] = "OTHER";
})(IndexSecurityTypeEnum = exports.IndexSecurityTypeEnum || (exports.IndexSecurityTypeEnum = {}));
var InvestmentObjective;
(function (InvestmentObjective) {
    InvestmentObjective["None"] = "None";
    InvestmentObjective["Preservation"] = "Preservation";
    InvestmentObjective["Growth"] = "Growth";
    InvestmentObjective["Hedge"] = "Hedge";
    InvestmentObjective["Speculation"] = "Speculation";
})(InvestmentObjective = exports.InvestmentObjective || (exports.InvestmentObjective = {}));
var InvestmentTenor;
(function (InvestmentTenor) {
    InvestmentTenor["None"] = "None";
    InvestmentTenor["Short"] = "Short";
    InvestmentTenor["MediumShort"] = "MediumShort";
    InvestmentTenor["Medium"] = "Medium";
    InvestmentTenor["MediumLong"] = "MediumLong";
    InvestmentTenor["Long"] = "Long";
})(InvestmentTenor = exports.InvestmentTenor || (exports.InvestmentTenor = {}));
var InvestorTypeEnum;
(function (InvestorTypeEnum) {
    InvestorTypeEnum["UNCLASSIFIED"] = "UNCLASSIFIED";
    InvestorTypeEnum["RETAIL"] = "RETAIL";
    InvestorTypeEnum["PROFESSIONAL"] = "PROFESSIONAL";
    InvestorTypeEnum["ELIGIBLE_COUNTERPARTY"] = "ELIGIBLE_COUNTERPARTY";
    InvestorTypeEnum["PROFESSIONAL_OPTED"] = "PROFESSIONAL_OPTED";
    InvestorTypeEnum["PENDING_PROFESSIONAL"] = "PENDING_PROFESSIONAL";
})(InvestorTypeEnum = exports.InvestorTypeEnum || (exports.InvestorTypeEnum = {}));
var KYCAccessGroupEnum;
(function (KYCAccessGroupEnum) {
    KYCAccessGroupEnum[KYCAccessGroupEnum["Value1"] = 1] = "Value1";
    KYCAccessGroupEnum[KYCAccessGroupEnum["Value3"] = 3] = "Value3";
    KYCAccessGroupEnum[KYCAccessGroupEnum["Value4"] = 4] = "Value4";
    KYCAccessGroupEnum[KYCAccessGroupEnum["Value5"] = 5] = "Value5";
    KYCAccessGroupEnum[KYCAccessGroupEnum["Value7"] = 7] = "Value7";
})(KYCAccessGroupEnum = exports.KYCAccessGroupEnum || (exports.KYCAccessGroupEnum = {}));
var Language;
(function (Language) {
    Language["EnUS"] = "en_US";
    Language["IsIS"] = "is_IS";
})(Language = exports.Language || (exports.Language = {}));
var OnboardingReviewItemsEnum;
(function (OnboardingReviewItemsEnum) {
    OnboardingReviewItemsEnum["PEP"] = "PEP";
    OnboardingReviewItemsEnum["RISK"] = "RISK";
    OnboardingReviewItemsEnum["PROFESSIONAL"] = "PROFESSIONAL";
    OnboardingReviewItemsEnum["BENEFICIAL_OWNERS_MISMATCH"] = "BENEFICIAL_OWNERS_MISMATCH";
    OnboardingReviewItemsEnum["DERIVATIVES"] = "DERIVATIVES";
})(OnboardingReviewItemsEnum = exports.OnboardingReviewItemsEnum || (exports.OnboardingReviewItemsEnum = {}));
var OnboardingStatus;
(function (OnboardingStatus) {
    OnboardingStatus["BLOCKED"] = "BLOCKED";
    OnboardingStatus["FINISHED"] = "FINISHED";
    OnboardingStatus["PIN_STEP"] = "PIN_STEP";
    OnboardingStatus["UNSUBMITTED"] = "UNSUBMITTED";
})(OnboardingStatus = exports.OnboardingStatus || (exports.OnboardingStatus = {}));
var OnboardingType;
(function (OnboardingType) {
    OnboardingType["CAPITAL_MARKETS"] = "CAPITAL_MARKETS";
    OnboardingType["GENERAL_BANKING"] = "GENERAL_BANKING";
    OnboardingType["PRIVATE_BANKING"] = "PRIVATE_BANKING";
    OnboardingType["DERIVATIVES"] = "DERIVATIVES";
})(OnboardingType = exports.OnboardingType || (exports.OnboardingType = {}));
var OnboardingTypeEnum;
(function (OnboardingTypeEnum) {
    OnboardingTypeEnum["CAPITAL_MARKETS"] = "CAPITAL_MARKETS";
    OnboardingTypeEnum["DERIVATIVES"] = "DERIVATIVES";
    OnboardingTypeEnum["GENERAL_BANKING"] = "GENERAL_BANKING";
    OnboardingTypeEnum["PRIVATE_BANKING"] = "PRIVATE_BANKING";
})(OnboardingTypeEnum = exports.OnboardingTypeEnum || (exports.OnboardingTypeEnum = {}));
var OrderByColumnEnum;
(function (OrderByColumnEnum) {
    OrderByColumnEnum["AgreementId"] = "AgreementId";
    OrderByColumnEnum["ClaimantId"] = "ClaimantId";
    OrderByColumnEnum["PayorId"] = "PayorId";
    OrderByColumnEnum["DueDate"] = "DueDate";
    OrderByColumnEnum["FinalDueDate"] = "FinalDueDate";
    OrderByColumnEnum["TotalAmountDue"] = "TotalAmountDue";
    OrderByColumnEnum["ClaimantName"] = "ClaimantName";
    OrderByColumnEnum["PayorName"] = "PayorName";
})(OrderByColumnEnum = exports.OrderByColumnEnum || (exports.OrderByColumnEnum = {}));
var OrderByDirectionEnum;
(function (OrderByDirectionEnum) {
    OrderByDirectionEnum["Asc"] = "Asc";
    OrderByDirectionEnum["Desc"] = "Desc";
})(OrderByDirectionEnum = exports.OrderByDirectionEnum || (exports.OrderByDirectionEnum = {}));
var PSD2AccountStatusEnum;
(function (PSD2AccountStatusEnum) {
    PSD2AccountStatusEnum["ENABLED"] = "ENABLED";
    PSD2AccountStatusEnum["DISABLED"] = "DISABLED";
})(PSD2AccountStatusEnum = exports.PSD2AccountStatusEnum || (exports.PSD2AccountStatusEnum = {}));
var PSD2PeriodicPaymentExecutionRuleEnum;
(function (PSD2PeriodicPaymentExecutionRuleEnum) {
    PSD2PeriodicPaymentExecutionRuleEnum["Following"] = "Following";
    PSD2PeriodicPaymentExecutionRuleEnum["Preceding"] = "Preceding";
})(PSD2PeriodicPaymentExecutionRuleEnum = exports.PSD2PeriodicPaymentExecutionRuleEnum || (exports.PSD2PeriodicPaymentExecutionRuleEnum = {}));
var PSD2PeriodicPaymentFrequencyEnum;
(function (PSD2PeriodicPaymentFrequencyEnum) {
    PSD2PeriodicPaymentFrequencyEnum["Daily"] = "Daily";
    PSD2PeriodicPaymentFrequencyEnum["Weekly"] = "Weekly";
    PSD2PeriodicPaymentFrequencyEnum["EveryTwoWeeks"] = "EveryTwoWeeks";
    PSD2PeriodicPaymentFrequencyEnum["Monthly"] = "Monthly";
    PSD2PeriodicPaymentFrequencyEnum["EveryTwoMonths"] = "EveryTwoMonths";
    PSD2PeriodicPaymentFrequencyEnum["Quarterly"] = "Quarterly";
    PSD2PeriodicPaymentFrequencyEnum["SemiAnnual"] = "SemiAnnual";
    PSD2PeriodicPaymentFrequencyEnum["Annual"] = "Annual";
})(PSD2PeriodicPaymentFrequencyEnum = exports.PSD2PeriodicPaymentFrequencyEnum || (exports.PSD2PeriodicPaymentFrequencyEnum = {}));
var PSD2TransactionBookingStatusEnum;
(function (PSD2TransactionBookingStatusEnum) {
    PSD2TransactionBookingStatusEnum["Booked"] = "booked";
    PSD2TransactionBookingStatusEnum["Pending"] = "pending";
    PSD2TransactionBookingStatusEnum["Both"] = "both";
})(PSD2TransactionBookingStatusEnum = exports.PSD2TransactionBookingStatusEnum || (exports.PSD2TransactionBookingStatusEnum = {}));
var PSD2TransactionStatusEnum;
(function (PSD2TransactionStatusEnum) {
    PSD2TransactionStatusEnum["ACCC"] = "ACCC";
    PSD2TransactionStatusEnum["ACCP"] = "ACCP";
    PSD2TransactionStatusEnum["ACFC"] = "ACFC";
    PSD2TransactionStatusEnum["ACSC"] = "ACSC";
    PSD2TransactionStatusEnum["ACSP"] = "ACSP";
    PSD2TransactionStatusEnum["ACTC"] = "ACTC";
    PSD2TransactionStatusEnum["ACWC"] = "ACWC";
    PSD2TransactionStatusEnum["ACWP"] = "ACWP";
    PSD2TransactionStatusEnum["CANC"] = "CANC";
    PSD2TransactionStatusEnum["PATC"] = "PATC";
    PSD2TransactionStatusEnum["PDNG"] = "PDNG";
    PSD2TransactionStatusEnum["RCVD"] = "RCVD";
    PSD2TransactionStatusEnum["RJCT"] = "RJCT";
})(PSD2TransactionStatusEnum = exports.PSD2TransactionStatusEnum || (exports.PSD2TransactionStatusEnum = {}));
var PSD2UnpaidBillClaimTypeEnum;
(function (PSD2UnpaidBillClaimTypeEnum) {
    PSD2UnpaidBillClaimTypeEnum["NormalClaim"] = "NormalClaim";
    PSD2UnpaidBillClaimTypeEnum["LightClaim"] = "LightClaim";
    PSD2UnpaidBillClaimTypeEnum["OptionalPaymentClaim"] = "OptionalPaymentClaim";
    PSD2UnpaidBillClaimTypeEnum["LightOptionalPaymentClaim"] = "LightOptionalPaymentClaim";
    PSD2UnpaidBillClaimTypeEnum["GovernmentalClaim"] = "GovernmentalClaim";
    PSD2UnpaidBillClaimTypeEnum["BalanceClaim"] = "BalanceClaim";
})(PSD2UnpaidBillClaimTypeEnum = exports.PSD2UnpaidBillClaimTypeEnum || (exports.PSD2UnpaidBillClaimTypeEnum = {}));
var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["CreditTransfer"] = "credit_transfer";
    PaymentTypeEnum["ClaimPayment"] = "claim_payment";
    PaymentTypeEnum["CreditCardDeposit"] = "credit_card_deposit";
})(PaymentTypeEnum = exports.PaymentTypeEnum || (exports.PaymentTypeEnum = {}));
var PortfolioTransactionMovementStatusTypeEnum;
(function (PortfolioTransactionMovementStatusTypeEnum) {
    PortfolioTransactionMovementStatusTypeEnum["CANCELED"] = "CANCELED";
    PortfolioTransactionMovementStatusTypeEnum["CONFIRMED"] = "CONFIRMED";
    PortfolioTransactionMovementStatusTypeEnum["REGISTERED"] = "REGISTERED";
    PortfolioTransactionMovementStatusTypeEnum["UNCONFIRMED"] = "UNCONFIRMED";
})(PortfolioTransactionMovementStatusTypeEnum = exports.PortfolioTransactionMovementStatusTypeEnum || (exports.PortfolioTransactionMovementStatusTypeEnum = {}));
var PortfolioTransactionTypeEnum;
(function (PortfolioTransactionTypeEnum) {
    PortfolioTransactionTypeEnum["ASSET_CHANGE_FREE"] = "ASSET_CHANGE_FREE";
    PortfolioTransactionTypeEnum["ASSET_CHANGE_VS_PAYM"] = "ASSET_CHANGE_VS_PAYM";
    PortfolioTransactionTypeEnum["BUY"] = "BUY";
    PortfolioTransactionTypeEnum["BUY_PENDING"] = "BUY_PENDING";
    PortfolioTransactionTypeEnum["CALLING"] = "CALLING";
    PortfolioTransactionTypeEnum["CAPITALTAX"] = "CAPITALTAX";
    PortfolioTransactionTypeEnum["CASH_DIVIDEND"] = "CASH_DIVIDEND";
    PortfolioTransactionTypeEnum["CUSTODIAN_TRANSFER"] = "CUSTODIAN_TRANSFER";
    PortfolioTransactionTypeEnum["DELIVER_FREE"] = "DELIVER_FREE";
    PortfolioTransactionTypeEnum["FEE"] = "FEE";
    PortfolioTransactionTypeEnum["INDEXATION"] = "INDEXATION";
    PortfolioTransactionTypeEnum["INSTALLMENT"] = "INSTALLMENT";
    PortfolioTransactionTypeEnum["INTEREST"] = "INTEREST";
    PortfolioTransactionTypeEnum["INVENTORY_TRANSFER"] = "INVENTORY_TRANSFER";
    PortfolioTransactionTypeEnum["LIQU"] = "LIQU";
    PortfolioTransactionTypeEnum["MERGE_SECURITIES"] = "MERGE_SECURITIES";
    PortfolioTransactionTypeEnum["PERFORMANCE_FEE"] = "PERFORMANCE_FEE";
    PortfolioTransactionTypeEnum["PORTFOLIO_ASSET_FEE"] = "PORTFOLIO_ASSET_FEE";
    PortfolioTransactionTypeEnum["PORTFOLIO_TRANSFER_IN"] = "PORTFOLIO_TRANSFER_IN";
    PortfolioTransactionTypeEnum["PORTFOLIO_TRANSFER_OUT"] = "PORTFOLIO_TRANSFER_OUT";
    PortfolioTransactionTypeEnum["PROXY_TRADE"] = "PROXY_TRADE";
    PortfolioTransactionTypeEnum["RECEIVE_FREE"] = "RECEIVE_FREE";
    PortfolioTransactionTypeEnum["REDEMPTION"] = "REDEMPTION";
    PortfolioTransactionTypeEnum["SAFEKEEPING_FEE"] = "SAFEKEEPING_FEE";
    PortfolioTransactionTypeEnum["SELL"] = "SELL";
    PortfolioTransactionTypeEnum["SELL_PENDING"] = "SELL_PENDING";
    PortfolioTransactionTypeEnum["SOFF"] = "SOFF";
    PortfolioTransactionTypeEnum["STOCK_DIVIDEND"] = "STOCK_DIVIDEND";
    PortfolioTransactionTypeEnum["STOCK_SPLIT"] = "STOCK_SPLIT";
    PortfolioTransactionTypeEnum["TRADING_FEE"] = "TRADING_FEE";
})(PortfolioTransactionTypeEnum = exports.PortfolioTransactionTypeEnum || (exports.PortfolioTransactionTypeEnum = {}));
var ProductCategoryEnum;
(function (ProductCategoryEnum) {
    ProductCategoryEnum["COMPANY_DEBIT_ACCOUNT"] = "COMPANY_DEBIT_ACCOUNT";
    ProductCategoryEnum["DEBIT_ACCOUNT"] = "DEBIT_ACCOUNT";
    ProductCategoryEnum["FX_ACCOUNT"] = "FX_ACCOUNT";
    ProductCategoryEnum["INDEXED_ACCOUNT"] = "INDEXED_ACCOUNT";
    ProductCategoryEnum["NOTICE31DAY"] = "NOTICE_31_DAY";
    ProductCategoryEnum["SAVINGS_ACCOUNT"] = "SAVINGS_ACCOUNT";
    ProductCategoryEnum["TERM_DEPOSIT"] = "TERM_DEPOSIT";
})(ProductCategoryEnum = exports.ProductCategoryEnum || (exports.ProductCategoryEnum = {}));
var ProductClassification;
(function (ProductClassification) {
    ProductClassification["Unclassified"] = "Unclassified";
    ProductClassification["Retail"] = "Retail";
    ProductClassification["Professional"] = "Professional";
    ProductClassification["EligibleCounterparty"] = "EligibleCounterparty";
    ProductClassification["ProfessionalOpted"] = "ProfessionalOpted";
})(ProductClassification = exports.ProductClassification || (exports.ProductClassification = {}));
var ProductEntityEnum;
(function (ProductEntityEnum) {
    ProductEntityEnum["KVIKA"] = "KVIKA";
    ProductEntityEnum["KES"] = "KES";
    ProductEntityEnum["AUDUR"] = "AUDUR";
})(ProductEntityEnum = exports.ProductEntityEnum || (exports.ProductEntityEnum = {}));
var ProductInterestFrequencyEnum;
(function (ProductInterestFrequencyEnum) {
    ProductInterestFrequencyEnum["MONTHLY"] = "MONTHLY";
    ProductInterestFrequencyEnum["YEARLY"] = "YEARLY";
})(ProductInterestFrequencyEnum = exports.ProductInterestFrequencyEnum || (exports.ProductInterestFrequencyEnum = {}));
var ProductTermEnum;
(function (ProductTermEnum) {
    ProductTermEnum["DAYS31"] = "DAYS_31";
    ProductTermEnum["MONTHS1"] = "MONTHS_1";
    ProductTermEnum["MONTHS3"] = "MONTHS_3";
    ProductTermEnum["MONTHS6"] = "MONTHS_6";
    ProductTermEnum["MONTHS12"] = "MONTHS_12";
    ProductTermEnum["UNBOUND"] = "UNBOUND";
})(ProductTermEnum = exports.ProductTermEnum || (exports.ProductTermEnum = {}));
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["CURRENT"] = "CURRENT";
    ProductTypeEnum["SAVINGS"] = "SAVINGS";
    ProductTypeEnum["NOTICE"] = "NOTICE";
    ProductTypeEnum["TERM_DEPOSIT"] = "TERM_DEPOSIT";
})(ProductTypeEnum = exports.ProductTypeEnum || (exports.ProductTypeEnum = {}));
var ProfessionalCategoryEnum;
(function (ProfessionalCategoryEnum) {
    ProfessionalCategoryEnum["OPERATING_LICENSE"] = "OPERATING_LICENSE";
    ProfessionalCategoryEnum["CORPORATION"] = "CORPORATION";
    ProfessionalCategoryEnum["GOVERNMENT"] = "GOVERNMENT";
    ProfessionalCategoryEnum["INSTITUTIONAL_INVESTOR"] = "INSTITUTIONAL_INVESTOR";
    ProfessionalCategoryEnum["ARTICLE54"] = "ARTICLE_54";
})(ProfessionalCategoryEnum = exports.ProfessionalCategoryEnum || (exports.ProfessionalCategoryEnum = {}));
var QuestionCategory;
(function (QuestionCategory) {
    QuestionCategory["Knowledge"] = "Knowledge";
    QuestionCategory["Experience"] = "Experience";
    QuestionCategory["FinancialSituation"] = "FinancialSituation";
    QuestionCategory["InvestmentObjectives"] = "InvestmentObjectives";
    QuestionCategory["RiskAversion"] = "RiskAversion";
    QuestionCategory["InvestmentTenor"] = "InvestmentTenor";
    QuestionCategory["InvestmentAmount"] = "InvestmentAmount";
    QuestionCategory["GeneralKnowledge"] = "GeneralKnowledge";
    QuestionCategory["AbilityToBearLoss"] = "AbilityToBearLoss";
})(QuestionCategory = exports.QuestionCategory || (exports.QuestionCategory = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["Textbox"] = "Textbox";
    QuestionType["RadioList"] = "RadioList";
    QuestionType["CheckboxList"] = "CheckboxList";
    QuestionType["RadioMatrix"] = "RadioMatrix";
    QuestionType["CheckboxMatrix"] = "CheckboxMatrix";
    QuestionType["DropDown"] = "DropDown";
    QuestionType["Hidden"] = "Hidden";
    QuestionType["LegalBinder"] = "LegalBinder";
    QuestionType["BeneficialOwner"] = "BeneficialOwner";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var RealmEnum;
(function (RealmEnum) {
    RealmEnum["INTERNAL"] = "INTERNAL";
    RealmEnum["PUBLIC"] = "PUBLIC";
    RealmEnum["EXTERNAL"] = "EXTERNAL";
})(RealmEnum = exports.RealmEnum || (exports.RealmEnum = {}));
var Risk;
(function (Risk) {
    Risk["None"] = "None";
    Risk["CurrencyRisk"] = "CurrencyRisk";
    Risk["InterestRateRisk"] = "InterestRateRisk";
})(Risk = exports.Risk || (exports.Risk = {}));
var RiskScoreEnum;
(function (RiskScoreEnum) {
    RiskScoreEnum["HIGH"] = "HIGH";
    RiskScoreEnum["ABOVE_AVERAGE"] = "ABOVE_AVERAGE";
    RiskScoreEnum["AVERAGE"] = "AVERAGE";
    RiskScoreEnum["BELOW_AVERAGE"] = "BELOW_AVERAGE";
    RiskScoreEnum["LOW"] = "LOW";
})(RiskScoreEnum = exports.RiskScoreEnum || (exports.RiskScoreEnum = {}));
var Score;
(function (Score) {
    Score["None"] = "None";
    Score["Low"] = "Low";
    Score["BelowAverage"] = "BelowAverage";
    Score["Average"] = "Average";
    Score["AboveAverage"] = "AboveAverage";
    Score["High"] = "High";
})(Score = exports.Score || (exports.Score = {}));
var SignatureStatus;
(function (SignatureStatus) {
    SignatureStatus["SCHEDULED"] = "SCHEDULED";
    SignatureStatus["STARTED"] = "STARTED";
    SignatureStatus["CODE_RECEIVED"] = "CODE_RECEIVED";
    SignatureStatus["SIGNED"] = "SIGNED";
    SignatureStatus["DECLINED"] = "DECLINED";
    SignatureStatus["IGNORED"] = "IGNORED";
    SignatureStatus["EXPIRED"] = "EXPIRED";
})(SignatureStatus = exports.SignatureStatus || (exports.SignatureStatus = {}));
var SignetDocumentStatus;
(function (SignetDocumentStatus) {
    SignetDocumentStatus[SignetDocumentStatus["Value0"] = 0] = "Value0";
    SignetDocumentStatus[SignetDocumentStatus["Value1"] = 1] = "Value1";
    SignetDocumentStatus[SignetDocumentStatus["Value2"] = 2] = "Value2";
    SignetDocumentStatus[SignetDocumentStatus["Value3"] = 3] = "Value3";
    SignetDocumentStatus[SignetDocumentStatus["Value4"] = 4] = "Value4";
    SignetDocumentStatus[SignetDocumentStatus["Value5"] = 5] = "Value5";
    SignetDocumentStatus[SignetDocumentStatus["Value6"] = 6] = "Value6";
    SignetDocumentStatus[SignetDocumentStatus["Value7"] = 7] = "Value7";
})(SignetDocumentStatus = exports.SignetDocumentStatus || (exports.SignetDocumentStatus = {}));
var StatusTypeEnum;
(function (StatusTypeEnum) {
    StatusTypeEnum["WaitingToBePaid"] = "WaitingToBePaid";
    StatusTypeEnum["DirectDebit"] = "DirectDebit";
    StatusTypeEnum["FuturePayment"] = "FuturePayment";
})(StatusTypeEnum = exports.StatusTypeEnum || (exports.StatusTypeEnum = {}));
var SubsidiaryEnum;
(function (SubsidiaryEnum) {
    SubsidiaryEnum["AUR"] = "AUR";
    SubsidiaryEnum["KES"] = "KES";
    SubsidiaryEnum["KVIKA"] = "KVIKA";
    SubsidiaryEnum["KVIKA_BANK"] = "KVIKA_BANK";
    SubsidiaryEnum["LYKILL"] = "LYKILL";
    SubsidiaryEnum["NETGIRO"] = "NETGIRO";
    SubsidiaryEnum["STRAUMUR"] = "STRAUMUR";
    SubsidiaryEnum["TM"] = "TM";
})(SubsidiaryEnum = exports.SubsidiaryEnum || (exports.SubsidiaryEnum = {}));
var SurveyType;
(function (SurveyType) {
    SurveyType["Aml"] = "aml";
    SurveyType["Appropriateness"] = "appropriateness";
    SurveyType["AudurFutureAccount"] = "audur_future_account";
    SurveyType["Suitability"] = "suitability";
    SurveyType["VendorAml"] = "vendor_aml";
})(SurveyType = exports.SurveyType || (exports.SurveyType = {}));
var UserRole;
(function (UserRole) {
    UserRole["BOARD_MEMBER"] = "BOARD_MEMBER";
    UserRole["CHAIRMAN_OF_THE_BOARD"] = "CHAIRMAN_OF_THE_BOARD";
    UserRole["COMANAGER"] = "COMANAGER";
    UserRole["CEO"] = "CEO";
    UserRole["POWER_OF_ATTORNEY"] = "POWER_OF_ATTORNEY";
    UserRole["OTHER"] = "OTHER";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserScopeEnum;
(function (UserScopeEnum) {
    UserScopeEnum["AUDUR"] = "AUDUR";
    UserScopeEnum["AUDUR__READ"] = "AUDUR__READ";
    UserScopeEnum["AUDUR__READ__PRODUCTS"] = "AUDUR__READ__PRODUCTS";
    UserScopeEnum["AUDUR__READ__SERVICE_STATUS"] = "AUDUR__READ__SERVICE_STATUS";
    UserScopeEnum["AUDUR__READ__USERS"] = "AUDUR__READ__USERS";
    UserScopeEnum["AUDUR__WRITE"] = "AUDUR__WRITE";
    UserScopeEnum["AUDUR__WRITE__PRODUCTS"] = "AUDUR__WRITE__PRODUCTS";
    UserScopeEnum["AUDUR__WRITE__PUSH"] = "AUDUR__WRITE__PUSH";
    UserScopeEnum["AUDUR__WRITE__SERVICE_STATUS"] = "AUDUR__WRITE__SERVICE_STATUS";
    UserScopeEnum["AUDUR__WRITE__USERS"] = "AUDUR__WRITE__USERS";
    UserScopeEnum["KVIKA"] = "KVIKA";
    UserScopeEnum["KVIKA__READ"] = "KVIKA__READ";
    UserScopeEnum["KVIKA__READ__ONBOARDING_APPLICATIONS"] = "KVIKA__READ__ONBOARDING_APPLICATIONS";
    UserScopeEnum["KVIKA__READ__SERVICE_STATUS"] = "KVIKA__READ__SERVICE_STATUS";
    UserScopeEnum["KVIKA__READ__COMPANIES"] = "KVIKA__READ__COMPANIES";
    UserScopeEnum["KVIKA__READ__KYC"] = "KVIKA__READ__KYC";
    UserScopeEnum["KVIKA__READ__USERS"] = "KVIKA__READ__USERS";
    UserScopeEnum["KVIKA__WRITE"] = "KVIKA__WRITE";
    UserScopeEnum["KVIKA__WRITE__ONBOARDING_APPLICATIONS"] = "KVIKA__WRITE__ONBOARDING_APPLICATIONS";
    UserScopeEnum["KVIKA__WRITE__SERVICE_STATUS"] = "KVIKA__WRITE__SERVICE_STATUS";
    UserScopeEnum["KVIKA__WRITE__COMPANIES"] = "KVIKA__WRITE__COMPANIES";
    UserScopeEnum["KVIKA__WRITE__KYC"] = "KVIKA__WRITE__KYC";
    UserScopeEnum["KVIKA__WRITE__USERS"] = "KVIKA__WRITE__USERS";
    UserScopeEnum["KVIKA__WRITE__PUSH"] = "KVIKA__WRITE__PUSH";
    UserScopeEnum["SELF"] = "SELF";
    UserScopeEnum["SELF__READ"] = "SELF__READ";
    UserScopeEnum["SELF__READ__SCOPES"] = "SELF__READ__SCOPES";
})(UserScopeEnum = exports.UserScopeEnum || (exports.UserScopeEnum = {}));
var VisibilityFilterEnum;
(function (VisibilityFilterEnum) {
    VisibilityFilterEnum["All"] = "All";
    VisibilityFilterEnum["Visible"] = "Visible";
    VisibilityFilterEnum["Hidden"] = "Hidden";
})(VisibilityFilterEnum = exports.VisibilityFilterEnum || (exports.VisibilityFilterEnum = {}));
//# sourceMappingURL=index.js.map